import { render, staticRenderFns } from "./RiskSurveyListing.vue?vue&type=template&id=68fa651c&"
import script from "./RiskSurveyListing.vue?vue&type=script&lang=js&"
export * from "./RiskSurveyListing.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurveyListing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports